<template>
  <div class="app v-public">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'PublicLayout',
  };
</script>
